import { useState } from 'react';
import { get } from 'lodash';
import { SortOutlinedIcon } from 'tuui';
import { sortFieldsOptions } from '../../../../modules/campaigns/components/CampaignPicker/CampaignPicker';
import { FormattedMessage } from '../../../../modules/taboola-common-frontend-modules/i18n';
import { useNodeWindowOverflow } from '../../hooks/useNodeWindowOverflow';
import { FieldSortingOption } from '../FieldSortingOption/FieldSortingOption';
import styles from './CampaignSorting.module.scss';

const dropdownRequiredWidth = 180;

export const CampaignSorting = ({ sort, onSort }) => {
    const [openSort, setOpenSort] = useState(false);
    const currentSortField = get(sort, '0.field');
    const currentOrderField = get(sort, '0.order');

    const { containerRef, overflowWidth } = useNodeWindowOverflow({
        requiredWidth: dropdownRequiredWidth,
    });

    return (
        <div className={styles['sorting-container']} ref={containerRef}>
            <SortOutlinedIcon className={styles['sorting-icon']} onClick={() => setOpenSort(prev => !prev)} />
            {openSort && (
                <div
                    className={styles['sorting-field-dropdown']}
                    style={overflowWidth ? { left: 'unset', right: 0 } : {}}
                >
                    <FormattedMessage
                        className={styles['sort-title']}
                        id="app.breadcrumbs.sort"
                        defaultMessage="Sort"
                    />
                    {sortFieldsOptions.map(({ value, label }) => (
                        <FieldSortingOption
                            key={value}
                            value={value}
                            label={label}
                            currentSortField={currentSortField}
                            currentOrderField={currentOrderField}
                            onSort={onSort}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};
